import { IAppState } from '../../common/state';

export function selectAggregatedOffers(state: IAppState): number {
  return state.results.aggregatedOffers;
}
